import { useAuth } from "../App";
import { isSuperAdmin } from "./useSuperAdmin";

export function useCanViewFunnel() {
  const { user } = useAuth();
  return user?.funnel_access === true || user?.role?.toLowerCase() === "admin" || isSuperAdmin(user?.email);
}
